import CheckLogin from "@/helper/checkLogin";
import { useEffect, useState, useRef } from "react";

export default function useFetchApi({
  url,
  params = {},
  body = "",
  method = "GET",
  skip = false,
  cacheTime = 30000,
  headers = {},
}) {
  const [trigger, setTrigger] = useState(0);
  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(([_, value]) => value !== undefined)
  );
  const queryParams = new URLSearchParams(filteredParams);

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [errors, setErrors] = useState([]);

  const cacheRef = useRef({});

  async function fetchApi(forceFetch = false) {
    if (!forceFetch && skip) {
      return {
        errors: [],
        loading: false,
        data: [],
      };
    }

    const cacheKey = `${url}?${queryParams}`;
    const cachedData = cacheRef.current[cacheKey];

    // Kiểm tra cache
    if (
      !forceFetch &&
      cachedData &&
      Date.now() - cachedData.timestamp < cacheTime
    ) {
      setData(cachedData?.data);
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const result = await (
        await fetch(
          `${
            url.includes("http") ? "" : process.env.NEXT_PUBLIC_API_HOST
          }${url}?${queryParams}`,
          {
            method: method,
            body: body ? JSON.stringify(body) : undefined,
            headers: {
              "Content-Type": "application/json",
              Authorization: CheckLogin(),
              ...headers,
            },
          }
        )
      ).json();
      const parsedResult = JSON.parse(
        JSON.stringify(result).replaceAll("&amp;", "&")
      );

      // Lưu vào cache
      cacheRef.current[cacheKey] = {
        data: parsedResult,
        timestamp: Date.now(),
      };

      setData(parsedResult);
    } catch (e) {
      console.error(e);
      setErrors((prevErrors) => [...prevErrors, e.message]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (!skip) {
      fetchApi();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, skip, trigger]);

  async function triggerFetch() {
    await fetchApi(true);
  }

  return {
    loading,
    data,
    setData,
    errors,
    setLoading,
    setErrors,
    triggerFetch,
  };
}
